import { Search, Library, Sparkles, Network, BotMessageSquare, PenLine, Target, ShieldCheck } from "lucide-react";
import { SectionHeading, FadeUp } from "./Reveal";

const ITEMS = [
  { title: "Consumer AI & intelligent search", Icon: Search },
  { title: "Enterprise knowledge systems", Icon: Library },
  { title: "Generative AI", Icon: Sparkles },
  { title: "RAG architectures", Icon: Network },
  { title: "Agentic AI", Icon: BotMessageSquare },
  { title: "Enterprise assistants", Icon: Target },
  { title: "Content intelligence", Icon: PenLine },
  { title: "AI-driven personalization", Icon: ShieldCheck },
];

export const EnterpriseAI = () => (
  <section data-testid="enterprise-ai-section" className="py-24 sm:py-32 bg-jx-mist relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-7">
          <SectionHeading
            testId="enterprise-ai"
            overline="Enterprise AI Experience"
            title={<>AI engineered for <span className="jx-gradient-text">real-world scale.</span></>}
          />
        </div>
        <FadeUp delay={0.2} className="lg:col-span-5">
          <p className="text-base sm:text-lg text-jx-ink/60 leading-relaxed border-l-2 border-jx-magenta pl-6">
            From prototypes to production-grade AI architectures, we design systems that are secure, scalable, governable and measurable.
          </p>
        </FadeUp>
      </div>

      <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-4">
        {ITEMS.map((item, i) => (
          <FadeUp key={item.title} delay={(i % 4) * 0.08}>
            <div
              data-testid={`ai-exp-card-${i}`}
              className="group h-full rounded-2xl bg-white border border-jx-ink/8 p-6 sm:p-8 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_rgb(0,0,0,0.07)] hover:border-jx-purple/25"
            >
              <div className="w-11 h-11 rounded-xl bg-jx-purple/8 flex items-center justify-center transition-colors duration-300 group-hover:jx-gradient-bg group-hover:bg-none">
                <item.Icon className="w-5 h-5 text-jx-purple transition-colors duration-300 group-hover:text-white" strokeWidth={1.8} />
              </div>
              <p className="mt-5 font-display font-bold text-base sm:text-lg tracking-tight text-jx-ink leading-snug">{item.title}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
